/**
 * The return leg of a redirect payment method (Bancontact, MobilePay, Klarna).
 *
 * The checkout sends the customer to Stripe with a return_url that carries
 * STRIPE_RETURN_QUERY_PARAM. A bank app can hand that URL to a different browser
 * than the one that started the checkout, so the page that receives it cannot
 * assume the cart or the payment session is in its localStorage; the webhook has
 * finalised the booking by then, and the page only has to say so.
 */
import i18n from '@base/i18n'
import { STRIPE_RETURN_QUERY_PARAM, STRIPE_RETURN_QUERY_VALUE } from '@base/configs'

export function isRedirectReturn (query) {
  return String(query[STRIPE_RETURN_QUERY_PARAM]) === STRIPE_RETURN_QUERY_VALUE
}

export function isRedirectReturnLocation () {
  const params = new URLSearchParams(window.location.search)
  return params.get(STRIPE_RETURN_QUERY_PARAM) === STRIPE_RETURN_QUERY_VALUE
}

export function paymentReceivedNotification () {
  return {
    group: 'app',
    type: 'success',
    title: i18n.t('notifications.title.success'),
    text: i18n.t('notifications.text.booking_requests.success_payment_received'),
  }
}
